module.exports = __webpack_public_path__ + "static/img/sop.403e6a43.png";